import { render, staticRenderFns } from "./EnrollmentsByMonth.vue?vue&type=template&id=1b37e9aa&"
import script from "./EnrollmentsByMonth.vue?vue&type=script&lang=js&"
export * from "./EnrollmentsByMonth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports